import { render } from "./documents_editor_page.vue?vue&type=template&id=21cee3bc"
import script from "./documents_editor_page.vue?vue&type=script&lang=js"
export * from "./documents_editor_page.vue?vue&type=script&lang=js"

import exportComponent from "/build/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__